import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-top-navigation-item-label',
  template: '<ng-content />'
})
export class MenuTopGlobalNavigationItemLabelComponent {
}
